import type { IndustryCategory } from '../../../types';
import { validateIndustryCatalog } from '../../domain/industry/IndustryPackValidator';
import {
  getPackForIndustry,
  resolveIndustryContent,
} from '../../domain/industry/resolveIndustryContent';
import type {
  IndustryContentRequest,
  IndustryContentSnapshot,
  IndustryPackDefinition,
} from '../../domain/industry/types';
import type { IIndustryCatalog } from '../../domain/ports/IIndustryCatalog';
import { INDUSTRY_PACK_REGISTRY } from './packs';

export class StaticIndustryCatalog implements IIndustryCatalog {
  constructor(private readonly packs: IndustryPackDefinition[] = INDUSTRY_PACK_REGISTRY) {}

  listPacks(): IndustryPackDefinition[] {
    return this.packs;
  }

  getPack(industryId: IndustryCategory): IndustryPackDefinition | undefined {
    return getPackForIndustry(this.packs, industryId);
  }

  resolveContent(request: IndustryContentRequest): IndustryContentSnapshot | undefined {
    const pack = this.getPack(request.industryId);
    if (!pack) return undefined;
    return resolveIndustryContent(pack, request);
  }

  validate() {
    return validateIndustryCatalog(this.packs);
  }

  listCategories() {
    return this.packs.map((p) => p.category);
  }

  isKnownIndustry(industryId: string): industryId is IndustryCategory {
    return this.packs.some((p) => p.id === industryId);
  }
}

export const industryCatalog = new StaticIndustryCatalog();